export default "__VITE_ASSET__f4e228db__"